
import axios from "axios";

const URL = "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@trabajoconsentido";
// const URL = "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/option-blog";

export default {
    getRSS: () => {
        const client = axios.create();
        client.defaults.headers.common = {};
        
        return new Promise((resolve, reject) => {
            client.get(URL).then(response => {
                resolve(response.data);
            }).catch(err => {
                reject(err);
            });
        });
    }
};
